import { hostelBusinessHomeRoute } from '../../megha/hostel-business-dashboard/hostel-route.util';
import { isHostelStoreType } from './hostel-store-types.util';

export interface HostelStoreLike {
  store_type?: string | null;
  store_code?: string | null;
}

/** First owned store that is PG / hostel (newest first from getUserStores). */
export function findPrimaryHostelStore<T extends HostelStoreLike>(
  stores: T[] | null | undefined
): T | null {
  if (!stores?.length) return null;
  return (
    stores.find((s) => isHostelStoreType(s.store_type) && String(s.store_code || '').trim()) ??
    null
  );
}

export function hostelDashboardCommands(storeCode: string): string[] {
  return hostelBusinessHomeRoute(storeCode);
}
